import React, {Component} from "react";
import {connect} from "react-redux";
import CarouselItem from "../../../../blocks/CarouselItem";
import Source from "../../../../items/Source";

import {BarChart} from "d3plus-react";

import {calculateDomain} from "../../../../../helpers/formatters";


class ProjectedOccupational extends Component {

  getChartConfig(data, xMin, xMax){
    return {
      data: data,
      detectVisible: true,
      groupBy: "isco_2_name",
      height: 250,
      legend: false,
      discrete: "y",
      y: "isco_2_name",
      x: "net_job_growth_18_30_in_percent",
      tooltipConfig: {
        body: d => `<div>${d.isco_2_name} net job growth: ${(d.net_job_growth_18_30_in_percent * 100).toFixed(1)}%</div>`
      },
      yConfig: {
        title: false,
        width: 100,
      },
      xConfig: {
        domain: calculateDomain(xMin, xMax),
        title: false,
        tickFormat: x => `${(x*100).toFixed(0)}%`
      },
      shapeConfig: {
        fill: d => d.color,
        duration: 0,
        Bar: {
          label: (d) => (`${(d.net_job_growth_18_30_in_percent * 100).toFixed(1)}%`)
        }
      },
      barPadding: 5,
      legendTooltip: {
        body: "",
        footer: "",
      },
      on: {"click.legend": () => {}}
    };
  }

  render() {
    const {selectedRegion, nuts3Data} = this.props;

    if (!nuts3Data || !selectedRegion) {
      return '';
    }

    const selectedRegionID = selectedRegion.id;
    const trends = nuts3Data.filter(n3 => n3.nuts3_id === selectedRegionID);

    let gMax = 0;
    const growing = [...trends.filter(n3 => n3.trend === 'G').map(r => {
      gMax = gMax < r.net_job_growth_18_30_in_percent ? r.net_job_growth_18_30_in_percent:gMax;
      r.value = r.net_job_growth_18_30_in_percent * 100;
      r.color ="#38bdf3";
      return r;
    })].sort((a,b)=>a.value<b.value?-1:1);

    let dMin = 0;
    const declining = [...trends.filter(n3 => n3.trend === 'D').map(r => {
      dMin = dMin > r.net_job_growth_18_30_in_percent ? r.net_job_growth_18_30_in_percent : dMin;
      r.value = r.net_job_growth_18_30_in_percent * 100;
      r.color = "#e5546c";
      return r;
    })].sort((a, b) => a.value < b.value ? 1 : -1);

    return (
      <CarouselItem title="Projected occupational shifts in %" subtitle={false}>
        <div className="fow-col fow-col-1-2 fow-lg-col-1">
          <h2 className="fow-font-text fow-font-size-lg fow-carousel-item-block-subtitle"><b>Top five growing occupations, growth rate 2018-30,</b> by ISCO2 category</h2>
          <BarChart config={this.getChartConfig(growing,0,gMax)} />
          <Source text="Source: Eurostat, Oxford Economics; McKinsey Global Institute analysis" />
        </div>
        <div className="fow-col fow-col-1-2 fow-lg-col-1">
          <h2 className="fow-font-text fow-font-size-lg fow-carousel-item-block-subtitle"><b>Top five declining occupations, growth rate 2018-30,</b> by ISCO2 category</h2>
          <BarChart config={this.getChartConfig(declining,dMin,0)} />
          <Source text="Source: Eurostat, Oxford Economics; McKinsey Global Institute analysis" />
        </div>
      </CarouselItem>
    );
  }
}

const mapStateToProps = state => {
  return {
    nuts3Data: state.db.data.facts.nuts3_top_occupations_future ? state.db.data.facts.nuts3_top_occupations_future : false,
    selectedRegion: state.settings.map["Regions"]
  };
};
const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ProjectedOccupational);
